module.exports = __webpack_public_path__ + "static/Grand_Driveway_Entrance-70fdee3406dd1d6555d3fe1e73f894af.jpg";